/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AutomationType/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Automatic from './Automatic/index'
import Manual from './Manual/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AutomationType({
  children,
  viewPath = "/DesignSystem/EditAutomation/TriggerType/AppointmentBookingsStateUpdate/Content/AutomationType"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Automatic'
let automationAutomationTypeValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'automation_type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: automationAutomationTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Automatic'}>
<Automatic
  viewPath={`${viewPath}/Automatic`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Manual'}>
<Manual
  viewPath={`${viewPath}/Manual`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}